import { TopBarPageContainer } from "@components/PageContainer";
import { Suspense } from "react";
import { RouteObject, useParams } from "react-router-dom";
import { TopBar } from "@components/TopBar";
import { LoadingSkeleton } from "@narmi/design_system";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { MessagesListV2 } from "@pages/messages_v2/MessagesListV2";
import { ThreadDetailsPageV2 } from "@pages/messages_v2/thread_details/ThreadDetailsV2";

export const MESSAGES_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { MessagesList } = await import("./MessagesList");
      const { Table } = await import("@components/Table");
      return {
        Component: () => {
          const { features } = useUserConfiguration();
          return (
            <Suspense
              fallback={
                // dummy fallback
                <TopBarPageContainer title="Messages">
                  <Table.Search onDebouncedChange={() => {}} />
                  <LoadingSkeleton isLoading />
                </TopBarPageContainer>
              }
            >
              <TopBarPageContainer title="Messages">
                {features.includes("secure_messages_redesign") ? (
                  <MessagesListV2 />
                ) : (
                  <MessagesList />
                )}
              </TopBarPageContainer>
            </Suspense>
          );
        },
      };
    },
  },
  {
    path: ":threadId",
    async lazy() {
      const { ThreadDetailsPage } = await import("./thread_details/ThreadDetails");
      return {
        Component() {
          const { features } = useUserConfiguration();
          const { threadId } = useParams<{ threadId: string }>();
          return (
            <Suspense fallback={<TopBar title="Messages" />}>
              {features.includes("secure_messages_redesign") ? (
                <ThreadDetailsPageV2 threadId={threadId!} />
              ) : (
                <ThreadDetailsPage threadId={threadId!} />
              )}
            </Suspense>
          );
        },
      };
    },
  },
];
